import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { UserResponse } from '../types/api/response/user';
import useCompanyInfo from './useCompanyInfo';

export default function useCompany(
  user: UserResponse,
  clientCompanyId?: string
) {
  const { companyId } = useParams();
  const id: string = useMemo(
    () =>
      !!clientCompanyId
        ? clientCompanyId
        : !!companyId
        ? companyId
        : !!user?.company?.id
        ? user.company.id
        : user?.companyId!,
    [companyId, user]
  );

  const { data, refetch } = useCompanyInfo(id);

  return { id, company: data?.company, refetch };
}
